const resumeLink = "https://drive.google.com/file/d/1OewGUTmEZypp3tgLArXa3fw70scr5koU/view?usp=share_link";

export { resumeLink }